<ng-container [ngSwitch]="property?.TypeClv">
  <span *ngSwitchCase="propertyTypes.Numeric">
    <ng-container *ngIf="property.IsMultiValue; else singleValue">
      <ng-container *ngFor="let value of (spec.Value | jsonParse : [])">
        {{value | decimalPlaces: property.RoundingFactor}}
      </ng-container>
    </ng-container>
    <ng-template #singleValue>
      {{(spec.NumericValue ?? spec.Default) | decimalPlaces : property.RoundingFactor }}
    </ng-template>
    <ng-container [ngTemplateOutlet]="unitTemplate"></ng-container>
  </span>
    <ng-container *ngSwitchCase="propertyTypes.Choice">
        <ng-container *ngIf="property.IsMultiValue; else singleValue">
            <ng-container *ngFor="let val of spec.Value | jsonParse : []">
                <ng-container *ngTemplateOutlet="choice; context: {value: val ?? spec.Default}"></ng-container>
            </ng-container>
        </ng-container>
        <ng-template #singleValue>
            <ng-container *ngTemplateOutlet="choice; context: {value: spec.ValueClv ?? spec.Default}"></ng-container>
        </ng-template>
        <ng-container [ngTemplateOutlet]="unitTemplate"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="propertyTypes.Text">
        <ng-container *ngIf="property.IsMultiValue; else singleValue">
            {{spec.Value | jsonParse: []}}
        </ng-container>
        <ng-template #singleValue>
            {{spec.Value ?? spec.Default}}
        </ng-template>
    </ng-container>
    <ng-container *ngSwitchCase="propertyTypes.Html">
      <button type="button" class="btn btn-sm btn-outline-primary" (click)="edit.emit(spec)" id="edit-{{spec.Id}}">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
      </button>
    </ng-container>
    <ng-container *ngSwitchCase="propertyTypes.DateTime">{{spec.DateTimeValue ?? spec.Default | date: 'dd.MM.yyyy'}}</ng-container>
    <ng-container *ngSwitchCase="propertyTypes.Json" class="font-monospace">
        <button type="button" class="btn btn-sm btn-outline-primary" title="{{spec.Value ?? spec.Default | shorten: 15: '...'}}" (click)="edit.emit(spec)" id="edit-{{spec.Id}}">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
        </button>
    </ng-container>
    <ng-container *ngSwitchDefault></ng-container>
</ng-container>

<ng-template #choice let-value="value">
    <ng-container *ngIf="(classificatorValuesQuery.selectEntity(value) | async) as clv">
        {{clv.DisplayName}}
        <ng-container *ngIf="clv.Data && (classificatorsQuery.selectEntity(clv.ClassificatorId) | async)?.TypeClv === classificatorTypes.Image">
            <img *ngLet="clv.Data | jsonParse as imageData" class="mw-100 h-auto ms-1" [src]="imageData.Path | assetImageUrl" [alt]="clv.Value" [style.max-height]="(imageData.MaxHeight ?? 256) + 'px'"/>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #unitTemplate>
    <span class="px-0 my-auto" *ngIf="showUnit && property.UnitId && (spec.NumericValue != null || spec.Default != null || spec.ValueClv != null || spec.Value != null)">{{property.UnitId | unit}}</span>
</ng-template>
